/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.5.0-nightly.2026.7.23",
    versionName: "0.5.0-nightly.2026.7.23",
    versionChannel: "nightly",
    buildDate: "2026-07-23T00:29:02.871Z",
    commitHash: "bd15bb33c2c1f47c22138b956e69ea567404dbb6",
};
